import useUserPreferencesStore from './UserPreferencesStore';

export default useUserPreferencesStore;
